import { AlertTriangle, RefreshCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ErrorCardProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

/**
 * Small inline error state, used wherever a React Query hook surfaces
 * isError. Keeps voice warm and actionable: one line of plain English, a
 * Try again button if a retry handler was supplied. Uses coral for the
 * icon to match the rest of the product's error semantics.
 */
export function ErrorCard({
  title = "Something didn't load",
  message = "Give it another go in a moment.",
  onRetry,
}: ErrorCardProps) {
  return (
    <div className="rounded-xl border border-coral/30 bg-coral/5 p-4 flex items-start gap-3">
      <AlertTriangle className="h-5 w-5 text-coral shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-navy">{title}</p>
        <p className="text-xs text-charcoal/60 mt-0.5">{message}</p>
      </div>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry}>
          <RefreshCcw className="h-3.5 w-3.5 mr-1.5" />
          Try again
        </Button>
      )}
    </div>
  );
}
